import { lazy } from 'react';

// Types
import { PrepaidCardMessageProps as LazyComponentProps } from './PrepaidCardMessage.types';

// Components
import withSuspense, { lazyRetry } from '@components/suspense';

const LazyComponent = lazy(() =>
  lazyRetry(() => import(/* webpackChunkName: "prepaidCardMessage" */ './PrepaidCardMessage')),
);

const LazyComponentWithSuspense = withSuspense<LazyComponentProps>(LazyComponent, 'PrepaidCardMessage');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as PrepaidCardMessage };
